import { readOnly, view } from '@yola/ws-sdk';
import { HOVER } from 'src/js/modules/custom-tools/constants/trigger-types';
import ColumnResizeTool from '../containers/column-resize-tool';

const getColumnElement = (element) => {
  const staticElement = view.accessors.getStaticElement(view.accessors.getLiveElementId(element));
  const column = staticElement && staticElement.closest('ws-column');
  return column ? view.accessors.getLiveElementByStaticElement(column) : null;
};

const columnResizeToolSettings = {
  triggerOn: HOVER,
  getTargetElement: getColumnElement,
  matches(element) {
    if (
      readOnly.verifiers.isReadOnlyModeEnabled() ||
      !element.closest('ws-block[id^="ws-block-custom-"]')
    ) {
      return false;
    }

    const columnElement = getColumnElement(element);
    return Boolean(columnElement);
  },
  container: ColumnResizeTool,
};

export default columnResizeToolSettings;
